var map = {
	"./confetti.png": 2480,
	"./modal-bg.png": 2481,
	"./notice.jpg": 2482,
	"./premier-league-bg.png": 2483,
	"./reward-1.png": 2484,
	"./reward-2.png": 2485,
	"./reward-3.png": 2486,
	"./reward-4.png": 2487,
	"./reward-6.png": 2488,
	"./reward-9.png": 2489,
	"./versus.png": 2490,
	"./white-button-active.png": 2491,
	"./white-button-inactive.png": 2492,
	"./win-2.png": 2493,
	"./win.png": 2494,
	"./world-cup-vs-bg-mobile.jpg": 2495,
	"./world-cup-vs-bg.jpg": 2496,
	"./入场劵.jpg": 2497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 175;